export default __webpack_public_path__ + "static/media/ic_frameworks.6019b0da.svg";